export interface QuestionType {
    readonly id: number;
    readonly name: string;
    readonly title?: string;
    readonly category?: number;
    readonly image?: string;
    readonly en?: string;
}
export interface ALLQuestionTypes {
    readonly texts: QuestionType[];
    readonly questions: QuestionType[];
    readonly buttons: QuestionType[];
}
export enum EQuestionType {
    Multi = 1, Autocomplete, Mark, FreeText, Number, Table , PhoneNumber, Range, Title, 
    Text, Link, UploadFile, Fill, Divider, Date, QuestionsGroup , Signature,Image,UploadFileAdmin, Expense
}